function HowItWorksWeb({ className }: { className?: string }) {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			viewBox="0 0 1632 326"
			preserveAspectRatio="none"
			fill="none"
		>
			<g style={{ mixBlendMode: "plus-lighter" }} opacity="0.3">
				<path
					d="M1620.67 320C1620.67 322.946 1623.05 325.333 1626 325.333C1628.95 325.333 1631.33 322.946 1631.33 320C1631.33 317.054 1628.95 314.667 1626 314.667C1623.05 314.667 1620.67 317.054 1620.67 320ZM0.666667 6C0.666667 8.94552 3.05448 11.3333 6 11.3333C8.94552 11.3333 11.3333 8.94552 11.3333 6C11.3333 3.05448 8.94552 0.666667 6 0.666667C3.05448 0.666667 0.666667 3.05448 0.666667 6ZM38 321H370V319H38V321ZM403 288V38H401V288H403ZM434 7H783V5H434V7ZM814 38V288H816V38H814ZM847 321H1198V319H847V321ZM1231 288V38H1229V288H1231ZM1262 7H1594V5H1262V7ZM1625 38V320H1627V38H1625ZM7 288V6H5V288H7ZM1594 7C1611.12 7 1625 20.8792 1625 38H1627C1627 19.7746 1612.23 5 1594 5V7ZM1231 38C1231 20.8792 1244.88 7 1262 7V5C1243.77 5 1229 19.7746 1229 38H1231ZM1198 321C1216.23 321 1231 306.225 1231 288H1229C1229 305.121 1215.12 319 1198 319V321ZM814 288C814 306.225 828.775 321 847 321V319C829.879 319 816 305.121 816 288H814ZM783 7C800.121 7 814 20.8792 814 38H816C816 19.7746 801.225 5 783 5V7ZM403 38C403 20.8792 416.879 7 434 7V5C415.775 5 401 19.7746 401 38H403ZM370 321C388.225 321 403 306.225 403 288H401C401 305.121 387.121 319 370 319V321ZM38 319C20.8792 319 7 305.121 7 288H5C5 306.225 19.7746 321 38 321V319Z"
					fill="white"
				/>
			</g>
		</svg>
	);
}

export default HowItWorksWeb;
